import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Row, Col, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
    editPoProject,
} from "../../../../actions";
import close from '../../../../assets/images/close.svg';


const renderSelectField = ({ input, meta: { touched, error }, children }) => (
    <div>
        <div>
            <select {...input} className='form-control form-select mt-4'>
                {children}
            </select>
            {touched && error && <p className="require">{error}</p>}
        </div>
    </div>
)

class EditPoProject extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            quantity: 0,
            discount: 0,
            productId: 0,
            items: [],
            total: 0,
            groupId: this.props.groupId,
            singleProduct: this.props.singleProduct,
            disabled: true,
            projectName: "",
            projectId: this.props.projectData?.projectId || "",
        }
        this.myRef = React.createRef();
        this.addGroupProduct = this.addGroupProduct.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
    }


    changeHandler(e) {
        this.setState({
            projectName: e.target.value
        })
    }
    addGroupProduct(values) {
        if (values.projectName !== "Various Projects  ") {
            if (!values.vertexId) {
                throw new SubmissionError({
                    vertexId: 'Please fill the field *',
                })
            } else if (!values?.salesExecutiveId) {
                throw new SubmissionError({
                    salesExecutiveId: 'Please fill the field *',
                })
            }
            let data = {
                "projectName": values.projectName,
                "projectId": this.props.projectId,
                "vertexId": Number(values.vertexId),
                "purchaseOrderId": Number(this.props.purchaseId),
                "salesExecutiveId": Number(values.salesExecutiveId),
            }
            this.props.dispatch(editPoProject(data));
        } else {
            let data = {
                "projectName": values.projectName,
                "projectId": this.props.projectId,
                // "vertexId": values.vertexId && Number(values.vertexId),
                "purchaseOrderId": Number(this.props.purchaseId),
                // "salesExecutiveId": values.salesExecutiveId && Number(values.salesExecutiveId),
                "isInStock": 1
            }
            this.props.dispatch(editPoProject(data));
        }
    }

    render() {
        const { handleSubmit, show, onHide, reset, load, projects } = this.props;
        console.log(this.state.projectName);

        return (
            <>
                <Modal
                    // contentClassName='po_modal'
                    show={show}
                    onHide={onHide}
                    size="xl"
                    centered
                    backdrop="static"
                    keyboard={false}
                >
                    <div className="modal-staff">
                        <form onSubmit={handleSubmit(this.addGroupProduct)}>
                            <div className="head">
                                <div>
                                    <i class="fas fa-arrow-left" onClick={() => {
                                        reset();
                                        onHide();
                                    }}></i>
                                    <h4>EDIT PROJECT</h4>
                                </div>
                                <span style={{ marginLeft: 'auto' }} onClick={() => {
                                    onHide();
                                    reset();
                                }}>
                                    <img src={close} alt="..." width="18px" style={{ cursor: "pointer" }} />
                                </span>
                            </div>
                            <Row className="modal-row-form">
                                <Col md={6}>
                                    <label class="form-control-placeholder" for="name">Select Project <span>*</span></label>
                                    <Field name="projectName" component={renderSelectField} className="form-control form-select" onChange={this.changeHandler}>
                                        <option value="" disabled={true} hidden={true}>Select Project *</option>
                                        {projects?.map((unit, i) =>
                                            <option value={unit?.label} key={i}>{unit?.label}</option>)}
                                    </Field>
                                    <div className="triangle-bottom"></div>
                                </Col>
                                <Col md={3}>
                                    <label class="form-control-placeholder" for="name">Select one Vertices <span>*</span></label>
                                    <Field name="vertexId" component={renderSelectField} className="form-control form-select" disabled={this.state.projectName === "Various Projects" ? true : false}>
                                        <option value="" disabled={true} hidden={true}>Select one Vertices *</option>
                                        <option value="" ></option>
                                        {this.props.verticesDropdown?.map(unit =>
                                            <option value={unit.vertexId} key={unit.vertexId}>{unit.vertexName}</option>)}
                                    </Field>
                                    <div className="triangle-bottom"></div>
                                </Col>
                                <Col md={3}>
                                    <label class="form-control-placeholder" for="name">Select one Sales Executive <span>*</span></label>
                                    <Field name="salesExecutiveId" component={renderSelectField} className="form-control form-select" disabled={this.state.projectName === "Various Projects" ? true : false}>
                                        <option value="" disabled={true} hidden={true}>Select one Sales Executive *</option>
                                        <option value=""  ></option>
                                        {this.props.salesExecutives && Array.isArray(this.props.salesExecutives) && this.props.salesExecutives.map(unit =>
                                            <option value={unit.userId} key={unit.userId}>{unit.salesExecutiveName}</option>)}
                                    </Field>
                                    <div className="triangle-bottom"></div>
                                </Col>
                                <Col md={4}></Col>
                                <Col md={4}>
                                    {!load ? <button type="submit" className="modal-btn sub-modal-btn">
                                        Update Project
                                    </button> : <button type="button" className="modal-btn sub-modal-btn">
                                        Loading ....
                                    </button>}
                                </Col>
                                <Col md={4}></Col>
                            </Row>
                        </form>
                    </div>
                </Modal>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        load: state.po.load,
        verticesDropdown: state.po.verticesDropdown,
        salesExecutives: state.qutation.salesExecutives,
        projectSuccess: state.po.projectSuccess
    }
}

const Form = reduxForm({
    form: "EditPoProject",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    // validate
})(EditPoProject);

export default connect(mapStateToProps)(Form);